export const USER_STATUS_CODE = Object.freeze({
    ACTIVE: "ACV",
    INACTIVE: "RJC",
});

export const USER_ROLES = Object.freeze({
    MANUFACTURER: "ROLE_MANUFACTURER",
    VALIDATOR_SUPERVISOR: "ROLE_VALIDATOR_SUPERVISOR",
    VALIDAOR_AGENT_N2: "ROLE_VALIDATOR_AGENT_N2",
    VALIDAOR_AGENT_N1: "ROLE_VALIDATOR_AGENT_N1",
    ADMIN: "ROLE_ADMIN",
    WORKER: "ROLE_WORKER",
});